"use client";

import { useConsentData } from "@/components/third-party/TruendoCookieConsent/TruendoConsentProvider";
import { useEffect } from "react";

const MOBILE_BANNER_RESERVE_PX = 420;

function clearTruendoBannerReserve(body: HTMLElement) {
  body.style.paddingBottom = "";
  delete body.dataset.truendoBannerReserve;
}

function markTruendoConsentGiven(body: HTMLElement) {
  clearTruendoBannerReserve(body);
  body.dataset.truendoConsent = "1";
}

/** Reserves bottom space on mobile so the Truendo banner does not shift layout. */
export function TruendoBannerReserve() {
  const { truendoBannerDismissed, truendoBlocked } = useConsentData();

  useEffect(() => {
    const body = document.body;
    const reserve = () => {
      if (body.dataset.truendoConsent === "1") {
        return;
      }

      if (window.matchMedia("(max-width: 768px)").matches) {
        body.style.paddingBottom = `${MOBILE_BANNER_RESERVE_PX}px`;
        body.dataset.truendoBannerReserve = "active";
      } else {
        clearTruendoBannerReserve(body);
      }
    };

    if (truendoBannerDismissed || truendoBlocked) {
      markTruendoConsentGiven(body);
      return;
    }

    reserve();
    window.addEventListener("resize", reserve);
    return () => window.removeEventListener("resize", reserve);
  }, [truendoBannerDismissed, truendoBlocked]);

  return null;
}
